<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <!-- Use a fluid container for full-width layout -->
    <b-container fluid class="container1">
      <b-row id="mcRow">
        <kn-sideMenu></kn-sideMenu>
        <main role="main" class="ml-sm-auto pt-3 px-4 mx-auto col-md-9" style="max-width: 100%;">
          <!--<kn-carousel></kn-carousel>-->
          <p></p>

          <h2>
            <span class="Block blue"></span>Τελευταίο Φύλλο:
          </h2>
          <b-embed type="iframe" aspect="1by1" class="pb-2 pt-2"
            src="https://www.kimoliaka-nea.gr/efimerides/efimerida_IOUL-AYG_2025.pdf" allowfullscreen>
          </b-embed>
        </main>
      </b-row>
    </b-container>

    <kn-footer></kn-footer>
  </div>
</template>

<script>
import jumbotron from "./jumbotron.vue";
import sideMenu from "./sideMenu.vue";
import carousel from "./carousel.vue";
import footer from "./footer.vue";

export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-carousel": carousel,
    "kn-footer": footer
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    }
  }
}
</script>

<style lang="scss">
.container {
  background: rgb(95, 171, 241);
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  border: 1px solid rgb(194, 192, 192);
  border-radius: 4px;
  box-shadow: 10px 10px 5px grey;
}

h2 {
  color: #333;
  font-family: Arial, sans-serif;
  border-top: 1px solid rgb(194, 192, 192);
  border-bottom: 1px solid rgb(194, 192, 192);

}

#mcRow {
  border: 1px solid rgb(194, 192, 192);
}

span.Block.blue {
  background: #4c81a6;
  display: inline-block;
  width: 5px;
  height: 23px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/mainContainer.vue